import { Button } from "antd"
import { useTranslation } from "react-i18next"

const MobileCtaButtons = ({ isMobile, onSaveForLater, onBack }) => {
  if (!isMobile) return null
  const { t } = useTranslation()

  return (
    <div className="pp-sticky-cta-mobile-top">
      {onBack ? (
        <Button type="default" size="large" style={{ width: "100%" }} onClick={onBack}>
          {t("Go back")}
        </Button>
      ) : null}
      <Button type="default" size="large" style={{ width: "100%" }} onClick={onSaveForLater}>
        {t("Save for later")}
      </Button>
    </div>
  )
}

export default MobileCtaButtons
